import request from '@/plugins/axios';

// 获取权限节点模板
//get 后缀
export function getPowerTemplate(params) {
    return request[0]({
        url: '/bmp/_internal_/authRole/getPowerTemplate',
        method: 'get',
        params
    })
}

// 添加角色
//post
export function addAuthRole(params, data) {
    return request[0]({
        url: '/bmp/_internal_/authRole/addAuthRole',
        method: 'post',
        params,
        data
    })
}

// 查询角色列表
//get 后缀
export function listAuthRole(params) {
    return request[0]({
        url: '/bmp/_internal_/authRole/listAuthRole',
        method: 'get',
        params
    })
}

// 删除角色
//get 后缀
export function deleteAuthRole(params) {
    return request[0]({
        url: '/bmp/_internal_/authRole/deleteAuthRole',
        method: 'get',
        params
    })
}

// 查询单个角色-基本信息
//get 后缀
export function getAuthRole(params) {
    return request[0]({
        url: '/bmp/_internal_/authRole/getAuthRole',
        method: 'get',
        params
    })
}

// 修改角色信息
//post
export function updateAuthRole(params, data) {
    return request[0]({
        url: '/bmp/_internal_/authRole/updateAuthRole',
        method: 'post',
        params,
        data
    })
}

// 获取角色权限列表
//get 后缀
export function getPowers(params) {
    return request[0]({
        url: '/bmp/_internal_/authRole/getPowers',
        method: 'get',
        params
    })
}

// 角色授权
//post
export function setPowers(params, data) {
    return request[0]({
        url: '/bmp/_internal_/authRole/setPowers',
        method: 'post',
        params,
        data
    })
}

// 查询内部用户列表
//get 后缀
export function listInternalUser(params) {
    return request[0]({
        url: '/bmp/_internal_/internalUser/listInternalUser',
        method: 'get',
        params
    })
}

// 修改内部用户信息
//post
export function updateInternalUser(params, data) {
    return request[0]({
        url: '/bmp/_internal_/internalUser/updateInternalUser',
        method: 'post',
        params,
        data
    })
}

// 添加内部用户
//post
export function addInternalUser(params, data) {
    return request[0]({
        url: '/bmp/_internal_/internalUser/addInternalUser',
        method: 'post',
        params,
        data
    })
}

// 查询单个内部用户-基本信息
//get 后缀
export function getInternalUser(params) {
    return request[0]({
        url: '/bmp/_internal_/internalUser/getInternalUser',
        method: 'get',
        params
    })
}